import { createContext, useContext } from 'react'

/**
 * Whether saved widgets on this page fetch their data together, in one
 * `POST /dashboards/batch-aggregate/` (api/widgetBatch). True on the signed-in
 * dashboard page; false everywhere else (share links, previews, metric pages),
 * which keep their single-widget requests.
 */
export const WidgetBatchContext = createContext(false)

/** @returns {boolean} */
export function useWidgetBatching() {
  return useContext(WidgetBatchContext)
}
